<script setup lang="ts">
import colors from 'tailwindcss/colors'
import { computed, Ref, ref } from "vue";

const theme: Ref<string> = ref(localStorage.theme === 'dark' ? 'dark' : 'light');
window.addEventListener('theme-changed', (event: CustomEvent<{ theme: string }>) => {
  theme.value = event.detail.theme;
});

const bgColor = computed(() => theme.value === 'dark' ? colors.neutral[800] : colors.white)
</script>

<template>
  <section class="h-8 sm:h-16 bg-gray-100 dark:bg-gray-700">
    <svg class="divider"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         viewBox="0 24 150 28 "
         preserveAspectRatio="none">
      <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
      </defs>
      <g class="parallax1">
        <use xlink:href="#gentle-wave" x="50" y="3" :fill="colors.green[400]"/>
      </g>
      <g class="parallax2">
        <use xlink:href="#gentle-wave" x="50" y="0" :fill="colors.green[500]"/>
      </g>
      <g class="parallax3">
        <use xlink:href="#gentle-wave" x="50" y="9" :fill="colors.green[600]"/>
      </g>
      <g class="parallax4">
        <use xlink:href="#gentle-wave" x="50" y="6" :fill="bgColor"/>
      </g>
    </svg>
  </section>
</template>

<style scoped lang="scss">
.divider {
  @apply absolute block w-full left-0 right-0 h-8 sm:h-16;
}

.parallax1 > use {
  animation: move-forever1 20s linear infinite;

  &:nth-child(1) {
    animation-delay: -2s;
  }
}

.parallax2 > use {
  animation: move-forever2 16s linear infinite;

  &:nth-child(1) {
    animation-delay: -2s;
  }
}

.parallax3 > use {
  animation: move-forever3 12s linear infinite;

  &:nth-child(1) {
    animation-delay: -2s;
  }
}

.parallax4 > use {
  animation: move-forever4 8s linear infinite;

  &:nth-child(1) {
    animation-delay: -2s;
  }
}

@keyframes move-forever1 {
  0% {
    transform: translate(85px, 0%);
  }
  100% {
    transform: translate(-90px, 0%);
  }
}

@keyframes move-forever2 {
  0% {
    transform: translate(-90px, 0%);
  }
  100% {
    transform: translate(85px, 0%);
  }
}

@keyframes move-forever3 {
  0% {
    transform: translate(85px, 0%);
  }
  100% {
    transform: translate(-90px, 0%);
  }
}

@keyframes move-forever4 {
  0% {
    transform: translate(-90px, 0%);
  }
  100% {
    transform: translate(85px, 0%);
  }
}
</style>
